import DateDisplay, { SHORT_DATE } from './DateDisplay'
import KeywordHighlight from './KeywordHighlight'
import User, { FIRST_LAST_INITIAL } from './User'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class OverlayInfo extends PureComponent {
  static propTypes = {
    date: PropTypes.string,
    searchHighlights: PropTypes.array,
    title: PropTypes.string,
    user: PropTypes.object,
    verb: PropTypes.string
  }

  static defaultProps = {
    searchHighlights: [],
    verb: 'Created By'
  }

  render() {
    const { date, searchHighlights, title, user, verb } = this.props
    const tokens = searchHighlights.reduce((memo, highlight) => {
      return memo.concat(highlight.tokens)
    }, [])

    return (
      <div style={{ marginBottom: 10 }}>
        <h6>
          <KeywordHighlight text={title} tokens={tokens} />
        </h6>
        <div className="layout-overlay-aside">
          <span>{I18n.t(verb)} </span>
          {user && <User user={user} format={FIRST_LAST_INITIAL} />}
          <span> {I18n.t('on')} </span>
          <DateDisplay date={date} format={SHORT_DATE} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/OverlayInfo.js